import { Paragraph, Heading } from "@digdir/designsystemet-react";
import type { QuoteBlockProps } from "./type";

export type { QuoteBlockProps };

export function QuoteBlock(props: QuoteBlockProps) {
	return (
		<div className="flex flex-col gap-2">
			<div className="flex gap-2 items-end">
				<Heading data-size="2xl" className="mb-1 text-neutral-text-subtle">
					&ldquo;
				</Heading>
				<Heading data-size="lg" data-epi-edit="Quote">
					{props.quote}
				</Heading>
				<Heading data-size="2xl" className="mb-1 text-neutral-text-subtle">
					&rdquo;
				</Heading>
			</div>
			<Paragraph data-size="sm" variant="short" data-epi-edit="Author">
				{props.author}
			</Paragraph>
		</div>
	);
}
